var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#101318"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6668 14.6667H13.3335L24.3468 29.352L13.9335 41.3334H17.4668L25.9842 31.5347L33.3335 41.3334H42.6668L31.1895 26.0294L41.0668 14.6667H37.5335L29.5522 23.848L22.6668 14.6667ZM34.6668 38.6667L18.6668 17.3334H21.3335L37.3335 38.6667H34.6668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterX);
export default __webpack_public_path__ + "static/media/twitterX.0541bfb987bb2b4645fc8581403ad4cd.svg";
export { ForwardRef as ReactComponent };